import { render, staticRenderFns } from "./OverrideModifierListSettings.vue?vue&type=template&id=65e1b260&"
import script from "./OverrideModifierListSettings.vue?vue&type=script&lang=js&"
export * from "./OverrideModifierListSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports